import React from 'react';
import '../template-file-css/document-file-template.css';


export const CBS_LhccOtr = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='CBS_LhccOtr' className='file-pdf-document'>
            <div className='file-template'>


                <h3>OUTPATIENT TREATMENT REQUEST FORM </h3>
                <p className='w-750'>
                    <strong>Use to request ACT, FFT, FFT-CW, Homebuilders, MST,<br />
                        Psychotherapy Services, Individual Placement and Support,
                        <br />
                        and Crisis Intervention Follow-up Services
                    </strong>

                </p>
                <p className='w-750'><strong>By fax to: 1-888-725-0101 </strong></p>
                <p className='w-750'>Please print clearly - incomplete or illegible forms will delay processing.</p>


                <h4>Instructions </h4>
                <p className='w-750'>Submit these documents:</p>
                <p className='w-750'>
                    <ul>
                        <li>This Outpatient Treatment Request form</li>
                        <li>LOCUS/CALOCUS Assessment (completed within last 180 days)
                        </li>
                        <li>Treatment Plan or Initial Treatment Goals
                        </li>
                        <li>Healthy Louisiana Behavioral Health Assessment (annually)
                        </li>
                        <li>Ensure to complete all questions in entirety to prevent a delay in processing

                        </li>
                    </ul>
                </p>

                <p className='w-750'>
                    or an adverse determination

                </p>
                <h4>Provider Information:</h4>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinician:  </span>
                            <input type="text" id="txtClinician" name="txtClinician" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Credentials: </span>
                            <input type="text" id="txtCredentials" name="txtCredentials" className='add-only' />
                        </td>

                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Agency Name: </span>
                            <input type="text" id="txtAgencyName" name="txtAgencyName" className='add-only' />
                        </td>

                        <td className='w-375'>
                            <span className='eleHeader'>Agency Address: </span>
                            <input type="text" id="txtAgencyAddress" name="txtAgencyAddress" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City: </span>
                            <input type="text" id="txtCity" name="txtCity" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>State: </span>
                            <input type="text" id="txtState" name="txtState" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip: </span>
                            <input type="text" id="txtZip" name="txtZip" className='add-only' />
                        </td>

                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Agency Phone: </span>
                            <input type="text" id="txtAgencyPhone" name="txtAgencyPhone" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Agency Secure Fax: </span>
                            <input type="text" id="txtAgencySecureFax" name="txtAgencySecureFax" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Agency NPI: </span>
                            <input type="text" id="txtAgencyNPI" name="txtAgencyNPI" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Agency TIN: </span>
                            <input type="text" id="txtAgencyTIN" name="txtAgencyTIN" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>Member Information:</h4>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>First Name: </span>
                            <input type="text" id="txtFirstName" name="txtFirstName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Last Name: </span>
                            <input type="text" id="txtLastName" name="txtLastName" className='add-only' />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Medicaid ID:</span>
                            <input type="text" id="txtMedicaidID" name="txtMedicaidID" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Birth Date:</span>
                            <input type="date" id="txtBirthDate" name="txtBirthDate" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Diagnosis ICD-10 Code: </span>
                            <input type="text" id="txtPrimaryDiagnosis" name="txtPrimaryDiagnosis" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Co-morbid Medical Diagnosis ICD-10 Code: </span>
                            <input type="text" id="txtMedicalDiagnosis" name="txtMedicalDiagnosis" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Additional:</span>
                            <input type="text" id="txtAdditional" name="txtAdditional" className='add-only' />
                        </td>

                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>Has contact occurred with PCP?
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbContactOccurred_Y" name="rbContactOccurred" className='add-only' value="Y" /> Yes &nbsp;
                            <input type="radio" id="rbContactOccurred_N" name="rbContactOccurred" className='add-only' value="N" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Does member participate in medical management?
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbMedicalManagement_Y" name="rbMedicalManagement" className='add-only' value="Y" /> Yes &nbsp;
                            <input type="radio" id="rbMedicalManagement_N" name="rbMedicalManagement" className='add-only' value="N" /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current Behavioral Health Medications: </span>
                            <input type="text" id="txtCurrentBehavioral" name="txtCurrentBehavioral" className='add-only' />
                        </td>


                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Medical Conditions: </span>
                            <input type="text" id="txtMedicalConditions" name="txtMedicalConditions" className='add-only' />
                        </td>
                    </tr>

                </table>


                <p className='w-750'>
                    <span className='eleHeader'>REQUESTED AUTHORIZATION (please mark appropriate code(s) in the left column) </span>

                </p>

                <strong>Note:</strong>
                <ul>

                    <li>Codes Requesting = Please indicate in the left column which codes you are requesting
                    </li>
                    <li>Req. = Requested
                    </li>
                    <li>tot# Unit Req. =  Total Number of Units Requested
                    </li>
                    <li># of Visits/Week =  Total Number of Visits Per Week
                    </li>
                </ul>
                <table>
                    <tr>
                        <td className='w-310'><span className='eleHeader'>odes Requesting  </span></td>
                        <td className='w-150'><span className='eleHeader'>Req. Start Date </span></td>
                        <td className='w-150'><span className='eleHeader'>Req. End Date </span></td>
                        <td className='w-70'><span className='eleHeader'>tot# Unit Req. </span></td>
                        <td className='w-70'><span className='eleHeader'># of Visits/ Week  </span></td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbCommunityPsychiatric" name="cbCommunityPsychiatric" className='add-only' value="Community Psychiatric" /></td>
                        <td className='w-290'>Community Psychiatric Supportive Treatment </td>
                        <td className='w-150'>
                            <input type="date" id="txtCommunityStartDate" name="txtCommunityStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtCommunityEndDate" name="txtCommunityEndDate" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtCommunityUnit" name="txtCommunityUnit" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtCommunityVisits" name="txtCommunityVisits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbHomebuilders" name="cbHomebuilders" className='add-only' value="Homebuilders" /></td>
                        <td className='w-290'>H0036 HK Homebuilders </td>
                        <td className='w-150'>
                            <input type="date" id="txtHomebuildersStartDate" name="txtHomebuildersStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtHomebuildersEndDate" name="txtHomebuildersEndDate" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtHomebuildersUnit" name="txtHomebuildersUnit" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtHomebuildersVisits" name="txtHomebuildersVisits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbTherapy" name="cbTherapy" className='add-only' value="Therapy" />
                        </td>
                        <td className='w-290'>H0036 HE Functional Family Therapy </td>
                        <td className='w-150'>
                            <input type="date" id="txtTherapyStartDate" name="txtTherapyStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtTherapyEndDate" name="txtTherapyEndDate" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtTherapyUnit" name="txtTherapy" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtTherapyVisits" name="txtTherapyVisits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbTherapyChildWelfare" name="cbTherapyChildWelfare" className='add-only' value="Therapy Child Welfare" /></td>
                        <td className='w-290'>H0036 HE Functional Family Therapy Child Welfare (FFT-CW) </td>
                        <td className='w-150'>

                            <input type="date" id="txtChildWelfareStartDate" name="txtChildWelfareStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtChildWelfareEndDate" name="txtChildWelfareEndDate" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtChildWelfareUnit" name="txtChildWelfareUnit" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtChildWelfareVisits" name="txtChildWelfareVisits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbAssertiveCommunity" name="cbAssertiveCommunity" className='add-only' value="Assertive Community" /></td>
                        <td className='w-290'>Assertive Community Treatment Program (ACT) H0039 </td>
                        <td className='w-150'>
                            <input type="date" id="txtAssertiveCommunityStartDate" name="txtAssertiveCommunityStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtAssertiveCommunityEndDate" name="txtAssertiveCommunityEndDate" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtAssertiveCommunityUnit" name="txtAssertiveCommunityUnit" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtAssertiveCommunityVisits" name="txtAssertiveCommunityVisits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMultisystemic" name="cbMultisystemic" className='add-only' value="Multisystemic" /></td>
                        <td className='w-290'>Multisystemic Family Therapy H2033 </td>
                        <td className='w-150'>

                            <input type="date" id="txtMultisystemicStartDate" name="txtMultisystemicStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtMultisystemicEndDate" name="txtMultisystemicEndDate" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtMultisystemicUnit" name="txtMultisystemicUnit" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtMultisystemicVisits" name="txtMultisystemicVisits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbIndividualPlacement" name="cbIndividualPlacement" className='add-only' value="Individual Placement" /></td>
                        <td className='w-290'>Individual Placement and Support H2024 </td>
                        <td className='w-150'>

                            <input type="date" id="txtIndividualPlacementStartDate" name="txtIndividualPlacementStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtIndividualPlacementEndDate" name="txtIndividualPlacementEndDate" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtIndividualPlacementUnit" name="txtIndividualPlacementUnit" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtIndividualPlacementVisits" name="txtIndividualPlacementVisits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbCrisisIntervention" name="cbCrisisIntervention" className='add-only' value="CrisisIntervention" /></td>
                        <td className='w-290'>Crisis Intervention follow up H2011 (no modifier) </td>
                        <td className='w-150'>
                            <input type="date" id="txtCrisisInterventionStartDate" name="txtCrisisInterventionStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtCrisisInterventionEndDate" name="txtCrisisInterventionEndDate" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtCrisisInterventionUnit" name="txtCrisisInterventionUnit" className='add-only' />
                        </td>
                        <td className='w-70'>
                            <input type="text" id="txtCrisisInterventionVisits" name="txtCrisisInterventionVisits" className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>PRIOR AUTHORIZATION FOR PSYCHOTHERAPY CODES (to be used AFTER Member has used 24 sessions that do not require a PA) </span>

                </p>




                <strong>Note:</strong>
                <ul>

                    <li>Codes Requesting = Please indicate in the left column which codes you are requesting
                    </li>
                    <li>Req. = Requested
                    </li>
                    <li>tot# Visits Req. =  Total Number of Visits Requested
                    </li>
                    <li># of Visits/Week =  Total Number of Visits Per Week
                    </li>
                </ul>


                <table>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-260'><strong>Codes Requesting </strong></td>
                        <td className='w-150'><strong>Req. Start Date </strong></td>
                        <td className='w-150'><strong>Req. End Date </strong></td>
                        <td className='w-90'><strong>tot# Visits Req.(not to exceed 12)</strong></td>
                        <td className='w-80'><strong># of Visits/Week </strong></td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbPsychotherapy30" name="cbPsychotherapy30" className='add-only' value="Psychotherapy 30mins." /></td>
                        <td className='w-260'>90832 Psychotherapy 30 min. with patient and/or family member </td>
                        <td className='w-150'>

                            <input type="date" id="txtPsychotherapy30StartDate" name="txtPsychotherapy30StartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtPsychotherapy30EndDate" name="txtEndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtPsychotherapy30Unit" name="txtPsychotherapy30Unit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtPsychotherapy30Visits" name="txtPsychotherapy30Visits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbService30" name="cbService30" className='add-only' value="Service 30mins." /></td>
                        <td className='w-260'>90833* Psychotherapy 30 min. with patient with patient and/or family member when performed with an E/M service </td>
                        <td className='w-150'>

                            <input type="date" id="txtService30StartDate" name="txtService30" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtService30EndDate" name="txtService30EndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtService30Unit" name="txtService30Unit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtService30Visits" name="txtService30Visits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbPsychotherapy45" name="cbPsychotherapy45" className='add-only' value="Psychotherapy 45mins." /></td>
                        <td className='w-260'>90834 Psychotherapy 45 min. with patient and/or family member </td>
                        <td className='w-150'>

                            <input type="date" id="txtPsychotherapy45StartDate" name="txtPsychotherapy45StartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtPsychotherapy45EndDate" name="txtPsychotherapy45EndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtPsychotherapy45Unit" name="txtPsychotherapy45Unit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtPsychotherapy45Visits" name="txtPsychotherapy45Visits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbService45" name="cbService45" className='add-only' value="Service 45mins." /></td>
                        <td className='w-260'>90836* Psychotherapy 45 min. with patient and/or family member when performed with an E/M service </td>
                        <td className='w-150'>

                            <input type="date" id="txtService45StartDate" name="txtService45StartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtService45EndDate" name="txtService45EndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtService45Unit" name="txtService45Unit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtService45Visits" name="txtService45Visits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbPsychotherapy60" name="cbPsychotherapy60" className='add-only' value="Psychotherapy 60mins." /></td>
                        <td className='w-260'>90837 Psychotherapy 60 min. with patient and/or family member
                        </td>
                        <td className='w-150'>

                            <input type="date" id="txtPsychotherapy60StartDate" name="txtPsychotherapy60StartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtPsychotherapy60EndDate" name="txtPsychotherapy60EndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtPsychotherapy60Unit" name="txtPsychotherapy60Unit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtPsychotherapy60Visits" name="txtPsychotherapy60Visits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbService60" name="cbService60" className='add-only' value="Service 60mins." /></td>
                        <td className='w-260'>90838* Psychotherapy 60 min. with patient and/or family member when performed with E/M service
                        </td>
                        <td className='w-150'>

                            <input type="date" id="txtService60StartDate" name="txtService60StartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtService60EndDate" name="txtService60EndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtService60Unit" name="txtService60Unit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtService60Visits" name="txtService60Visits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbPsychotherapyCrisis" name="cbPsychotherapyCrisis" className='add-only' value="Psychotherapy Crisis" /></td>
                        <td className='w-260'>90840 Psychotherapy for Crisis each additional 30 min
                        </td>
                        <td className='w-150'>

                            <input type="date" id="txtPsychotherapyCrisisStartDate" name="txtPsychotherapyCrisisStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtPsychotherapyCrisisEndDate" name="txtPsychotherapyCrisisEndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtPsychotherapyCrisisUnit" name="txtPsychotherapyCrisisUnit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtPsychotherapyCrisisVisits" name="txtPsychotherapyCrisisVisits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbConjointPsychotherapy" name="cbConjointPsychotherapy" className='add-only' value="Conjoint Psychotherapy" /></td>
                        <td className='w-260'>90847 Family Psychotherapy conjoint psychotherapy; with patient present
                        </td>
                        <td className='w-150'>

                            <input type="date" id="txtConjointPsychotherapyStartDate" name="txtConjointPsychotherapyStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtConjointPsychotherapyEndDate" name="txtConjointPsychotherapyEndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtConjointPsychotherapyUnit" name="txtConjointPsychotherapyUnit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtConjointPsychotherapyVisits" name="txtConjointPsychotherapyVisits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbGroupPsychotherapy" name="cbGroupPsychotherapy" className='add-only' value="Group Psychotherapy" /></td>
                        <td className='w-260'>90849 Multiple Family Group Psychotherapy
                        </td>
                        <td className='w-150'>

                            <input type="date" id="txtGroupPsychotherapyStartDate" name="txtGroupPsychotherapyStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtGroupPsychotherapyEndDate" name="txtGroupPsychotherapyEndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtGroupPsychotherapyUnit" name="txtGroupPsychotherapyUnit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtGroupPsychotherapyVisits" name="txtGroupPsychotherapyVisits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMultipleFamily" name="cbMultipleFamily" className='add-only' value="Service 45mins." /></td>
                        <td className='w-260'>90853 Group Psychotherapy other than of a multiple family group
                        </td>
                        <td className='w-150'>

                            <input type="date" id="txtMultipleFamilyStartDate" name="txtMultipleFamilyStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtMultipleFamilyEndDate" name="txtMultipleFamilyEndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtMultipleFamilyUnit" name="txtMultipleFamilyUnit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtMultipleFamilyVisits" name="txtMultipleFamilyVisits" className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbPsychoanalysis" name="cbPsychoanalysis" className='add-only' value="Psychoanalysis" /></td>
                        <td className='w-260'>90845 Psychoanalysis
                        </td>
                        <td className='w-150'>

                            <input type="date" id="txtPsychoanalysisStartDate" name="txtPsychoanalysisStartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtPsychoanalysisEndDate" name="txtPsychoanalysisEndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtPsychoanalysisUnit" name="txtPsychoanalysisUnit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtPsychoanalysisVisits" name="txtPsychoanalysisVisits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbBiofeedback30" name="cbBiofeedback30" className='add-only' value="Biofeedback 30mins." /></td>
                        <td className='w-260'>90875 Individual Therapy with Biofeedback 30 min.
                        </td>
                        <td className='w-150'>

                            <input type="date" id="txtBiofeedback30StartDate" name="txtBiofeedback30StartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtBiofeedback30EndDate" name="txtBiofeedback30EndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtBiofeedback30Unit" name="txtBiofeedback30Unit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtBiofeedback30Visits" name="txtBiofeedback30Visits" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbBiofeedback60" name="cbBiofeedback60" className='add-only' value="Service 45mins." /></td>
                        <td className='w-260'>90876 Individual Therapy with Biofeedback 60 min
                        </td>
                        <td className='w-150'>

                            <input type="date" id="txtBiofeedback60StartDate" name="txtBiofeedback60StartDate" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtBiofeedback60EndDate" name="txtBiofeedback60EndDate" className='add-only' />
                        </td>
                        <td className='w-90'>
                            <input type="text" id="txtBiofeedback60Unit" name="txtBiofeedback60Unit" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" id="txtBiofeedback60Visits" name="txtBiofeedback60Visits" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>FUNCTIONAL OUTCOMES (choose yes or no) </span>
                </p>

                <table>
                    <tr>
                        <td className='w-650'>1. In the last 30 days, has member been in crisis?</td>
                        <td className='w-50'>
                            <input type="radio" id="rbCrisis_Y" name="rbCrisis" className='add-only' value="Y" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbCrisis_N" name="rbCrisis" className='add-only' value="N" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>2. In the last 30 days, has member received inpatient or residential behavioral health care?</td>
                        <td className='w-50'>
                            <input type="radio" id="rbBehavioral_Y" name="rbBehavioral" className='add-only' value="Y" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbBehavioral_N" name="rbBehavioral" className='add-only' value="N" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>3. In the last 30 days, has the member had problems with sleeping or feeling sad?</td>
                        <td className='w-50'>
                            <input type="radio" id="rbSleeping_Y" name="rbSleeping" className='add-only' value="Y" /> Yes

                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbSleeping_N" name="rbSleeping" className='add-only' value="N" /> No

                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>4. In the last 30 days, has the member had problems with had problems with fears and anxiety?</td>
                        <td className='w-50'>
                            <input type="radio" id="rbAnxiety_Y" name="rbAnxiety" className='add-only' value="Y" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbAnxiety_N" name="rbAnxiety" className='add-only' value="N" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>5. In the last 30 days, has alcohol or drug use caused problems for member?</td>
                        <td className='w-50'>
                            <input type="radio" id="rbDrug_Y" name="rbDrug" className='add-only' value="Y" /> Yes

                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbDrug_N" name="rbDrug" className='add-only' value="N" /> No

                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>6. In the last 30 days, has member gotten in trouble with the law? </td>
                        <td className='w-50'>
                            <input type="radio" id="rbLaw_Y" name="rbLaw" className='add-only' value="Y" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbLaw_N" name="rbLaw" className='add-only' value="N" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>7. In the last 30 days, has member had trouble getting along with other people including family and people out the home?</td>
                        <td className='w-50'>
                            <input type="radio" id="rbFamilyPeople_Y" name="rbFamilyPeople" className='add-only' value="Y" /> Yes

                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbFamilyPeople_N" name="rbFamilyPeople" className='add-only' value="N" /> No

                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>8. In the last 30 days, has member had an unstable living situation? </td>
                        <td className='w-50'>
                            <input type="radio" id="rbUnstableLiving_Y" name="rbUnstableLiving" className='add-only' value="Y" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbUnstableLiving_N" name="rbUnstableLiving" className='add-only' value="N" /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'><strong>CHILDREN ONLY</strong></p>
                <table>
                    <tr>
                        <td className='w-650'>9. In the last 30 days, has member been suspended or expelled from school?</td>
                        <td className='w-50'>
                            <input type="radio" id="rbSuspended_Y" name="rbSuspended" className='add-only' value="Y" /> Yes

                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbSuspended_N" name="rbSuspended" className='add-only' value="N" /> No

                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>10. Is member currently in state custody (DCFS or Juvenile Justice)? </td>
                        <td className='w-50'>
                            <input type="radio" id="rbCustody_Y" name="rbCustody" className='add-only' value="Y" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbCustody_N" name="rbCustody" className='add-only' value="N" /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'><strong>ADULTS ONLY</strong></p>
                <table>
                    <tr>
                        <td className='w-650'>11. Is member currently employed or attending school?</td>
                        <td className='w-50'>
                            <input type="radio" id="rbEmployed_Y" name="rbEmployed" className='add-only' value="Y" /> Yes

                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbEmployed_N" name="rbEmployed" className='add-only' value="N" /> No

                        </td>
                    </tr>
                    <tr>
                        <td className='w-650'>12. Has Member recently transitioned from a nursing facility or been diverted from nursing facility level of care through the My Choice Louisiana program?
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbLouisiana_Y" name="rbLouisiana" className='add-only' value="Y" /> Yes
                        </td>
                        <td className='w-50'>
                            <input type="radio" id="rbLouisiana_N" name="rbLouisiana" className='add-only' value="N" /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>SYMPTOMS (IF PRESENT, SELECT DEGREE TO WHICH IT IMPACTS DAILY FUNCTIONING.)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-350'>&nbsp;</td>
                        <td className='w-100'><span className='eleHeader'>N/A</span></td>
                        <td className='w-100'><span className='eleHeader'>Mild</span></td>
                        <td className='w-100'><span className='eleHeader'>Moderate</span></td>
                        <td className='w-100'><span className='eleHeader'>Severe</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Anxiety/Panic Attacks </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSymptoms_1" id="rbSymptomsNa_1" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSymptoms_1" id="rbSymptomsMild_1" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSymptoms_1" id="rbSymptomsModerate_1" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" name="rbSymptoms_1" id="rbSymptomsSevere_1" className='add-only' value="Severe" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Impulsivity </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsNa_3" name="rbSymptoms_3" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsMild_3" name="rbSymptoms_3" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsModerate_3" name="rbSymptoms_3" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsSevere_3" name="rbSymptoms_3" className='add-only' value="Severe" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Social Withdrawal </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsNa_5" name="rbSymptoms_5" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsMild_5" name="rbSymptoms_5" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsModerate_5" name="rbSymptoms_5" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsSevere_5" name="rbSymptoms_5" className='add-only' value="Severe" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Depressed Mood  </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsNa_7" name="rbSymptoms_7" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsMild_7" name="rbSymptoms_7" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsModerate_7" name="rbSymptoms_7" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsSevere_7" name="rbSymptoms_7" className='add-only' value="Severe" />
                        </td>
                    </tr>

                    <tr>

                        <td className='w-350'> Hopelessness </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsNa_2" name="rbSymptoms_2" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsMild_2" name="rbSymptoms_2" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsModerate_2" name="rbSymptoms_2" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsSevere_2" name="rbSymptoms_2" className='add-only' value="Severe" />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-350'> Decreased Energy </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsNa_4" name="rbSymptoms_4" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsMild_4" name="rbSymptoms_4" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsModerate_4" name="rbSymptoms_4" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsSevere_4" name="rbSymptoms_4" className='add-only' value="Severe" />
                        </td>


                    </tr>
                    <tr>
                        <td className='w-350'> Mood Swings </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsNa_6" name="rbSymptoms_6" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsMild_6" name="rbSymptoms_6" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsModerate_6" name="rbSymptoms_6" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsSevere_6" name="rbSymptoms_6" className='add-only' value="Severe" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'> Hyperactivity </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsNa_8" name="rbSymptoms_8" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsMild_8" name="rbSymptoms_8" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsModerate_8" name="rbSymptoms_8" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsSevere_8" name="rbSymptoms_8" className='add-only' value="Severe" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Outbursts/Anger </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsNa_9" name="rbSymptoms_9" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsMild_9" name="rbSymptoms_9" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsModerate_9" name="rbSymptoms_9" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbSymptomsSevere_9" name="rbSymptoms_9" className='add-only' value="Severe" />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>FUNCTIONAL IMPAIRMENT (IF PRESENT, SELECT DEGREE TO WHICH IT IMPACTS DAILY FUNCTIONING.)
                    </span>
                </p>
                <table>
                    <tr>
                        <td className='w-350'>&nbsp;</td>
                        <td className='w-100'><span className='eleHeader'>N/A</span></td>
                        <td className='w-100'><span className='eleHeader'>Mild</span></td>
                        <td className='w-100'><span className='eleHeader'>Moderate</span></td>
                        <td className='w-100'><span className='eleHeader'>Severe</span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Personal Hygiene </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentNa_1" name="rbFunctionalImpairment_1" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentMild_1" name="rbFunctionalImpairment_1" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentModerate_1" name="rbFunctionalImpairment_1" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentSevere_1" name="rbFunctionalImpairment_1" className='add-only' value="Severe" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Relationships </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentNa_3" name="rbFunctionalImpairment_3" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentMild_3" name="rbFunctionalImpairment_3" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentModerate_3" name="rbFunctionalImpairment_3" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentSevere_3" name="rbFunctionalImpairment_3" className='add-only' value="Severe" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Physical Health </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentNa_5" name="rbFunctionalImpairment_5" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentMild_5" name="rbFunctionalImpairment_5" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentModerate_5" name="rbFunctionalImpairment_5" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentSevere_5" name="rbFunctionalImpairment_5" className='add-only' value="Severe" />
                        </td>
                    </tr>
                    <tr>

                        <td className='w-350'>Sleep </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentNa_4" name="rbFunctionalImpairment_4" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentMild_4" name="rbFunctionalImpairment_4" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentModerate_4" name="rbFunctionalImpairment_4" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentSevere_4" name="rbFunctionalImpairment_4" className='add-only' value="Severe" />
                        </td>
                    </tr>
                    <tr>

                        <td className='w-350'>Medication Compliance </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentNa_6" name="rbFunctionalImpairment_6" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentMild_6" name="rbFunctionalImpairment_6" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentModerate_6" name="rbFunctionalImpairment_6" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentSevere_6" name="rbFunctionalImpairment_6" className='add-only' value="Severe" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Substance Use (Current) </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentNa_7" name="rbFunctionalImpairment_7" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentMild_7" name="rbFunctionalImpairment_7" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentModerate_7" name="rbFunctionalImpairment_7" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentSevere_7" name="rbFunctionalImpairment_7" className='add-only' value="Severe" />
                        </td>

                    </tr>
                    <tr>

                        <td className='w-350'>Work/School </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentNa_2" name="rbFunctionalImpairment_2" className='add-only' value="Na" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentMild_2" name="rbFunctionalImpairment_2" className='add-only' value="Mild" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentModerate_2" name="rbFunctionalImpairment_2" className='add-only' value="Moderate" />
                        </td>
                        <td className='w-100'>
                            <input type="radio" id="rbFunctionalImpairmentSevere_2" name="rbFunctionalImpairment_2" className='add-only' value="Severe" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List Substance Used </span>
                    <input type="text" id="txtListSubstance" name="txtListSubstance" className='add-only' />
                </p>

                <h4>CURRENT RISK ASSESSMENT (select all that apply) </h4>

                <p className='w-750'>
                    <span className='eleHeader'>Suicidal </span>
                    <input type="radio" id="rbSuicidal_None" name="rbSuicidal" className='add-only' value="None" /> None &nbsp;
                    <input type="radio" id="rbSuicidal_Ideation" name="rbSuicidal" className='add-only' value="Ideation" /> Ideation &nbsp;
                    <input type="radio" id="rbSuicidal_Planned" name="rbSuicidal" className='add-only' value="Planned" /> Planned &nbsp;
                    <input type="radio" id="rbSuicidal_Intent" name="rbSuicidal" className='add-only' value="Imminent Intent" /> Imminent Intent &nbsp;
                    <input type="radio" id="rbSuicidal_Self" name="rbSuicidal" className='add-only' value="Self Injury" /> Self Injury
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>History of self-harming behavior (dates)</span>
                    <input type="date" id="txtSelfHarming1" name="txtSelfHarming1" className='add-only' />
                    <input type="text" id="txtSelfHarming2" name="txtSelfHarming2" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Homicidal </span>
                    <input type="radio" id="rbHomicidal_None" name="rbHomicidal" className='add-only' value="None" /> None &nbsp;
                    <input type="radio" id="rbHomicidal_Ideation" name="rbHomicidal" className='add-only' value="Ideation" /> Ideation &nbsp;
                    <input type="radio" id="rbHomicidal_Planned" name="rbHomicidal" className='add-only' value="Planned" /> Planned &nbsp;
                    <input type="radio" id="rbHomicidal_Intent" name="rbHomicidal" className='add-only' value="Imminent Intent" /> Imminent Intent &nbsp;
                    <input type="radio" id="rbHomicidal_Others" name="rbHomicidal" className='add-only' value="Injury to others" /> Injury to others
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>History of harm to others (dates)</span>
                    <input type="date" id="txtHarmingOthers1" name="txtHarmingOthers1" className='add-only' />
                    <input type="text" id="txtHarmingOthers2" name="txtHarmingOthers2" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Safety Plan in place? </span>
                    <input type="radio" id="rbSafetyPlan_Yes" name="rbSafetyPlan" className='add-only' value="Yes" /> Yes
                    <input type="radio" id="rbSafetyPlan_No" name="rbSafetyPlan" className='add-only' value="No" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any recent crisis:
                    </span>
                    <textarea id="txtRecentCrisis" name="txtRecentCrisis" className='add-only'></textarea>
                </p>
                <h4>TREATMENT GOALS, PROGRESS, AND BARRIERS </h4>

                <p className='w-750'>
                    <span className='eleHeader'>Goal 1:</span>
                    <textarea id="txtGoal1" name="txtGoal1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>Specific Progress Made</strong>
                    <textarea id="txtGoal1Progress" name="txtGoal1Progress" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>Continued Barriers to Goal Attainment</strong>
                    <textarea id="txtGoal1Barriers" name="txtGoal1Barriers" className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Goal 2:</span>
                    <textarea id="txtGoal2" name="txtGoal2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>Specific Progress Made</strong>
                    <textarea id="txtGoal2Progress" name="txtGoal2Progress" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>Continued Barriers to Goal Attainment</strong>
                    <textarea id="txtGoal2Barriers" name="txtGoal2Barriers" className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Goal 3:</span>
                    <textarea id="txtGoal3" name="txtGoal3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>Specific Progress Made</strong>
                    <textarea id="txtGoal3Progress" name="txtGoal3Progress" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>Continued Barriers to Goal Attainment</strong>
                    <textarea id="txtGoal3Barriers" name="txtGoal3Barriers" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Goal 4:</span>
                    <textarea id="txtGoal4" name="txtGoal4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>Specific Progress Made</strong>
                    <textarea id="txtGoal4Progress" name="txtGoal4Progress" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <strong>Continued Barriers to Goal Attainment</strong>
                    <textarea id="txtGoal4Barriers" name="txtGoal4Barriers" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Describe presenting problems</span>
                    <textarea id="txtPresentingProblems" name="txtPresentingProblems" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If this is a re-authorization, please provide a brief narrative expressing the success or lack of
                        success during the previous authorization period.
                    </span>
                    <textarea id="txtAuthorization" name="txtAuthorization" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe what worked for the member, what did not work for the member, and how member's
                        symptoms specifically continue to impair functioning.
                    </span>
                    <textarea id="txtSymptoms" name="txtSymptoms" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    Please feel free to attach additional documentation to support your request (e.g. updated treatment
                    plan, progress notes, etc.).
                </p>

                <table>
                    <tr>
                        <td className="signature w-500">&nbsp;</td>
                        <td className="signature w-250">&nbsp;</td>
                    </tr>

                    <tr>
                        <td className="small w-500">Clinician printed name with Credentials</td>
                        <td className="small w-250">Date:</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="signature w-500">&nbsp;</td>
                        <td className="signature w-250">&nbsp;</td>
                    </tr>

                    <tr>
                        <td className="small w-500">Clinician Signature with Credentials

                        </td>
                        <td className="small w-250">Date:</td>
                    </tr>
                </table>


            </div>
        </form>

    )
} 